import React, {useEffect} from 'react';
import {PrivateRoute, useSignOut} from "react-auth-kit";
import {validateUser} from "../utils/utils";
import {useLocation} from "react-router-dom";

const CustomRoute = ({path, component, exact, redirectAfterLogin = false}) => {
    const signOut = useSignOut();
    let loginPath = "/booking/login";
    const location = useLocation();
    if (redirectAfterLogin)
        loginPath += `?redirect=${location.pathname}`;

    useEffect(() => {
        const token = localStorage.getItem('user');
        if (!token) return;
        validateToken(token).catch();
    }, []);

    const validateToken = async () => {
        const data = await validateUser();
        if (data.status === 'success' && !data.validate)
            signOut();
    };


    return (
        <PrivateRoute path={path} exact={exact} component={component} loginPath={loginPath} />
    );
};

export default CustomRoute;